/**
 * Off-Canvas Menu
 * Replaces Foundation data-off-canvas with class-based toggle + CSS transitions.
 */

const SELECTORS = {
  toggle: '[data-off-canvas-toggle]',
  panel: '#offCanvas',
  wrapper: '.off-canvas-wrapper',
  content: '.off-canvas-content',
};

const CLASSES = {
  open: 'is-open',
  active: 'is-active',
  bodyOpen: 'off-canvas-open',
};

function init() {
  const panel = document.querySelector(SELECTORS.panel);
  if (!panel) return;

  const toggles = document.querySelectorAll(SELECTORS.toggle);
  const wrapper = document.querySelector(SELECTORS.wrapper);

  // Create overlay element for closing on backdrop click
  const overlay = document.createElement('div');
  overlay.className = 'off-canvas-overlay';
  overlay.setAttribute('aria-hidden', 'true');
  wrapper?.appendChild(overlay);

  // Track which element triggered the open so we can restore focus on close
  let triggerElement = null;

  function open() {
    triggerElement = document.activeElement;

    panel.classList.add(CLASSES.open);
    document.body.classList.add(CLASSES.bodyOpen);
    overlay.classList.add(CLASSES.open);
    toggles.forEach((btn) => btn.classList.add(CLASSES.active));
    panel.setAttribute('aria-hidden', 'false');

    // Trap focus — move focus into panel
    const firstFocusable = panel.querySelector('a, button, [tabindex="0"]');
    firstFocusable?.focus();
  }

  function close() {
    panel.classList.remove(CLASSES.open);
    document.body.classList.remove(CLASSES.bodyOpen);
    overlay.classList.remove(CLASSES.open);
    toggles.forEach((btn) => btn.classList.remove(CLASSES.active));
    panel.setAttribute('aria-hidden', 'true');

    // Restore focus to the element that opened the menu
    triggerElement?.focus();
    triggerElement = null;
  }

  function toggle() {
    panel.classList.contains(CLASSES.open) ? close() : open();
  }

  // Toggle buttons
  toggles.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      toggle();
    });
  });

  // Close on overlay click
  overlay.addEventListener('click', close);

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && panel.classList.contains(CLASSES.open)) {
      close();
    }
  });
}

// Auto-init on DOMContentLoaded or immediately if DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
